import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "./Footer";

const ResponsiblePlay = () => {
  return (
    <>
    <div className="terms-service">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <div className="terms-content mt-4 mb-5 p-4">
              <h1 className="text-center mb-4">🎯 Responsible Gaming</h1>
              <p className="version-info text-center mb-4">
                Last updated: March 27, 2025
              </p>
  
              <p>At Silvertidequest, we are committed to making gaming fun, safe, and healthy. We offer only social casino games that are free to play and do not involve real money.</p>
  
              <h2>💡 What Does Responsible Gaming Mean?</h2>
              <p>Responsible gaming means playing for entertainment – without it affecting your daily life, finances, or relationships.</p>
              <p>Even though our games do not involve real money, it's still important to maintain healthy gaming habits.</p>
  
              <h2>✅ Our Principles for Responsible Gaming:</h2>
              <ul>
                <li>🎮 Play for fun – not as a way to solve problems</li>
                <li>🧘 Take breaks – avoid playing for extended periods without a pause</li>
                <li>⏰ Set time limits – and stick to them</li>
                <li>👀 Be aware – recognize signs of addiction or compulsion</li>
                <li>🔞 The platform is for users over 18 only</li>
              </ul>
  
              <h2>⚠️ Concerned About Your or Someone Else’s Gaming Behavior?</h2>
              <p>If you feel that gaming is getting out of control – even free games – we encourage you to talk to someone.</p>
              <p>👉 Hjelpelinjen.no offers free and anonymous counseling services in Netherlands:</p>
              <p>🔗 <a href="http://www.loketkansspel.nl" target="_blank" rel="noopener noreferrer">www.loketkansspel.nl</a></p>
              <p>📞 06 598 183 31 (open 24/7)</p>
  
              <h2>🔒 Safe Gaming at Silvertidequest</h2>
              <ul>
                <li>Silvertidequest only offers free social casino games</li>
                <li>There are no bets, purchases, or chances to win real money</li>
                <li>Progress in our games does not provide any advantage in real-money gambling</li>
              </ul>
  
              <h2>🧠 Need Tips?</h2>
              <ul>
                <li>Play with friends – make it social</li>
                <li>Set personal limits: for time and frequency</li>
                <li>Remember: It's just a game, not a competition to win</li>
              </ul>
  
              <h2>📩 Contact Us</h2>
              <p>Do you have questions or need support?</p>
              <p>Silvertidequest AS</p>
              <p>📧 Silvertidequest@gmail.com</p>
              <p>📍 Assen Drenthe Brink 23, 9401 HT Assen, Netherlands</p>
              <p>📞 +31 36 533 6736</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    <Footer />
  </>
  
  );
};

export default ResponsiblePlay;
